// extracted by mini-css-extract-plugin
module.exports = {"resultHeader":"styles_resultHeader__3ih3C","resultOption":"styles_resultOption__1EqGh","iconWrapper":"styles_iconWrapper__2lhjU","details":"styles_details__2igZS"};